import { useParams } from "react-router-dom";
import RitualDetail from "./RitualDetail";
import RitualObjectDetail from "./RitualObjectDetail";

const BALM_SLUGS = new Set(["encens", "cuir", "cachemire"]);

/**
 * Router shim: /rituals/:slug hits balms (Encens/Cuir/Cachemire) OR
 * one of the Bath/Body/Soul ritual objects (kotcha, ritual-cleanser, candle, ...).
 */
export default function RitualEntry() {
  const { slug } = useParams();
  return BALM_SLUGS.has(slug) ? <RitualDetail /> : <RitualObjectDetail />;
}
